/**
 * 2025 Tax Year Rules
 * Combines federal and state rules
 */

import { cashMedicalSupportLevelsIA2026 } from './IA/cashMedicalSupportLevels';
import { childSupportLevelsIA2026 } from './IA/childSupportLevels';
import { TaxRules } from '../../types';

export const taxRules2026: TaxRules = {
    year: 2026,
    federal: {
        filing: {
            single: {
                standardDeduction: 16_100,
                over65Deduction: 8_050, // 2050 + 6000
                blindDeduction: 2_050,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 12_400.00, rate: 0.10 },
                    { minimumIncome: 12_400.01, maximumIncome: 50_400.00, rate: 0.12 },
                    { minimumIncome: 50_400.01, maximumIncome: 105_700.00, rate: 0.22 },
                    { minimumIncome: 105_700.01, maximumIncome: 201_775.00, rate: 0.24 },
                    { minimumIncome: 201_775.01, maximumIncome: 256_225.00, rate: 0.32 },
                    { minimumIncome: 256_225.01, maximumIncome: 640_600.00, rate: 0.35 },
                    { minimumIncome: 640_600.01, rate: 0.37 },
                ],
            },
            marriedFilingSeparately: {
                standardDeduction: 16_100,
                over65Deduction: 8_050, // 2050 + 6000
                blindDeduction: 2_050,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 12_400.00, rate: 0.10 },
                    { minimumIncome: 12_400.01, maximumIncome: 50_400.00, rate: 0.12 },
                    { minimumIncome: 50_400.01, maximumIncome: 105_700.00, rate: 0.22 },
                    { minimumIncome: 105_700.01, maximumIncome: 201_775.00, rate: 0.24 },
                    { minimumIncome: 201_775.01, maximumIncome: 256_225.00, rate: 0.32 },
                    { minimumIncome: 256_225.01, maximumIncome: 384_350.00, rate: 0.35 },
                    { minimumIncome: 384_350.01, rate: 0.37 },
                ],
            },
            headOfHousehold: {
                standardDeduction: 24_150,
                over65Deduction: 8_050, // 2050 + 6000
                blindDeduction: 2_050,
                brackets: [
                    { minimumIncome: 0, maximumIncome: 17_700.00, rate: 0.10 },
                    { minimumIncome: 17_700.01, maximumIncome: 67_450.00, rate: 0.12 },
                    { minimumIncome: 67_450.01, maximumIncome: 105_700.00, rate: 0.22 },
                    { minimumIncome: 105_700.01, maximumIncome: 201_750.00, rate: 0.24 },
                    { minimumIncome: 201_750.01, maximumIncome: 256_200.00, rate: 0.32 },
                    { minimumIncome: 256_200.01, maximumIncome: 640_600.00, rate: 0.35 },
                    { minimumIncome: 640_600.01, rate: 0.37 },
                ],
            }
        },
        fica: {
            regularSocialSecurityRate: 6.2,
            seSocialSecurityRate: 12.4,
            regularMedicareRate: 1.45,
            seMedicareRate: 1.45,
            additionalMedicareTaxRate: 0.90,
            socialSecurityThreshold: 184_500,
            additionalMedicareTaxThreshold: 200_000,
        },
        credits: {
            federalCreditPerDependentUnder17: 2_200,
            federalRefundableAmountPerChildUnder17: 1_700,
            federalCreditPerDependent17Over: 500,
            childTaxCreditPhaseOutThreshold: 200_000,
            phaseOutAmountPerChild: 50,
            dollarAbovePhaseoutThresholdIncrement: 1_000,
        },
        qbi: {
            tentativeRate: 0.20,
            thresholdStart: 201_750,
            thresholdEnd: 276_750,
            thresholdRate: 0.025
        },
        earnedIncome: {
            threshold: 2_500,
            agiMultiplier: 15.0,
        },
        dependentCare: {
            limitOneDependent: 3000,
            limitTwoOrMoreDependents: 6000,
        },
    },
    states: {
        IA: {
            // Iowa state tax - flat rate for 2026
            standardDeductionSingle: 0,
            standardDeductionMarriedFilingSeparately: 0,
            standardDeductionHeadOfHousehold: 0,
            over65Deduction: 20,
            blindDeduction: 20,
            brackets: [
                { minimumIncome: 0, rate: 0.038 }, // 3.8% flat rate
            ],
            personalCredit: {
                single: 40,
                marriedFilingSeparately: 40,
                headOfHousehold: 80,
                perDependent: 40,
            },
            qadd: [
                { count: 0, rate: 0.00, minimum: 0 },
                { count: 1, rate: 0.08, minimum: 9_600 },
                { count: 2, rate: 0.12, minimum: 14_400 },
                { count: 3, rate: 0.14, minimum: 16_800 },
                { count: 4, rate: 0.15, minimum: 18_000 },
                { count: 5, rate: 0.16, minimum: 19_200 },
            ],
            support: {
                childSupport: childSupportLevelsIA2026,
                cashMedicalSupport: cashMedicalSupportLevelsIA2026,
            },
        },
    },
};
